import React, { useState } from 'react'
import { useAuth0 } from '@auth0/auth0-react'
import { Button } from '@material-ui/core'
import { ApiClient } from '../../common'

const AITokenActionButton = ({ action, payload, title, dispatchResponse }) => {
  const [isLoading, setLoading] = useState(false)
  const { getAccessTokenSilently } = useAuth0()

  const regenerateToken = async (token) => {
    return await ApiClient.patch(
      `/ai/entitlements/${payload.entitlementId}/token`,
      token
    )
      .then((response) => {
        if (response.status === 200) {
          return { success: true, data: response.data }
        } else {
          return { success: false }
        }
      })
      .catch(() => {
        return { success: false }
      })
  }

  const createToken = async (token) => {
    return await ApiClient.post(`/ai/entitlements`, token, {
      productSfid: payload.productSfid,
    })
      .then((response) => {
        if (response.status === 200) {
          return { success: true, data: response.data }
        } else {
          return { success: false }
        }
      })
      .catch(() => {
        return { success: false }
      })
  }
  const handleSubmit = async () => {
    const token = await getAccessTokenSilently()
    let response = {}
    if (action === 'create') {
      response = await createToken(token)
    } else {
      response = await regenerateToken(token)
    }
    setLoading(false)

    if (response?.success) {
      return dispatchResponse(true, response.data)
    }
    return dispatchResponse(false, null)
  }

  return (
    <>
      <Button
        disabled={isLoading}
        variant="contained"
        color="primary"
        size="small"
        onClick={(e) => {
          e.stopPropagation() // prevent triggering onSelect
          setLoading(true)
          handleSubmit()
        }}
      >
        {isLoading ? '....' : title}
      </Button>
    </>
  )
}

export default AITokenActionButton
